import type {Language, ValidationFn} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {join, tap, map} from 'ramda'
import {validate} from '@/validation'
import {appSelectors} from '@/store'
import {getElementIdName} from '@/views/util'

type Props = {
  l: Language,
  label: string,
  defaultValue: string,
  value: string,
  onChange: () => void,
  validators: Array<ValidationFn>,
  disable?: boolean,
  helpText?: string,
  isRequired?: boolean,
  placeholder?: string,
}

class RawEditField extends Component<Props> {
  constructor (props) {
    super(props)

    this.state = {
      errors: [],
    }
  }

  validateField = () => {
    if (!this.field) return

    const recordErrors = (errors) => this.setState({errors})
    const resetErrors = () => this.setState({errors: []})

    return validate(this.props.validators, this.field.value)
      .mapFailure(tap(recordErrors))
      .map(tap(resetErrors))
  }

  inputClasses = () => {
    const base = 'form-group'

    return this.state.errors.length
      ? `${base} has-error`
      : base
  }

  render = () =>
    <div className={this.inputClasses()}>
      <label>{this.props.l(this.props.label)} {this.props.isRequired ? ' *' : null}
        <input
          className="form-control"
          id={getElementIdName(this.props.label)}
          ref={(input) => { this.field = input }}
          type="text"
          placeholder={this.props.l(this.props.placeholder || this.props.label)}
          defaultValue={this.props.defaultValue}
          value={this.props.value}
          onClick={() => setTimeout(this.validateField, 1000)}
          onChange={() => {
            this.validateField().fold(
              () => this.props.onChange(undefined), // Bad value, delete it
              this.props.onChange, // Valid, save it
            )
          }}
          disabled={this.props.disable}
        />
        {this.props.helpText ? <span className='help-text'>{this.props.l(this.props.helpText)}</span> : false}
      </label>
      {this.state.errors
        ? <span className="help-block">{join(' ', map((error) => this.props.l(error), this.state.errors))}</span>
        : null
      }
    </div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawEditField)



// WEBPACK FOOTER //
// ./src/controls/edit-field.js